/**
 * List Schema of CargaDestinatario
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {CargaDestinatario} from '@/model/resource/CargaDestinatario'

/* TODO: review generated schema */
export class ListCargaDestinatarioSchema extends Schema {
  readonly name = 'ListCargaDestinatario'

  readonly fieldSet: FieldSet<CargaDestinatario> = {
    carga: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.carga?.$id,
      },
    }),
    endereco: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.endereco?.$id,
      },
    }),
    nome: (): FieldComponent => ({
      is: Component.Render,
    }),
    cpfCnpj: (): FieldComponent => ({
      is: Component.Render,
    }),
    telefone: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.phone(schema.model.telefone),
      },
    }),
    indicadorIe: (): FieldComponent => ({
      is: Component.Render,
    }),
    inscricaoEstadual: (): FieldComponent => ({
      is: Component.Render,
    }),
    inscricaoSuframa: (): FieldComponent => ({
      is: Component.Render,
    }),
    im: (): FieldComponent => ({
      is: Component.Render,
    }),
    email: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
